var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97695 2.09264C4.08517 1.03309 1.09854 3.78098 4.50329 5.93106M4.50329 5.93106C1.88252 6.90172 1.10793 9.57689 2.05575 10.8288C3.00357 12.0808 5.21413 12.1056 8.16513 10.0114M4.50329 5.93106L5.64708 5.52015M9.00004 18L13 8.99996L17 18M16.0999 16H9.89994",
    stroke: "#81A63D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLang);
export default __webpack_public_path__ + "static/media/lang.47d7e958c1921fe0d1e1409e8e1afecd.svg";
export { ForwardRef as ReactComponent };